import React, { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { BugOutlined, CheckCircleOutlined } from '@ant-design/icons';

import { useMutation } from '@tanstack/react-query';
import Spin from 'components/Spin';
import QueryString from 'query-string';
import { confirmationService } from 'services/ConfirmationService';
import Footer from 'v2/components/Shared/Footer';

const REDIRECT_DELAY_MS = 10_000;

const ModerateCoproducer = () => {
  const location = useLocation();
  const history = useHistory();
  const urlParams = useMemo(() => QueryString.parse(location.search), [location.search]);

  const status = urlParams.status === 'approved' ? 'Aprovado' : 'Reprovado';
  const hasValidParameters = Boolean(urlParams.k && urlParams.status);

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: confirmationService.changeCoproducerStatus,
    onSettled: () => {
      setTimeout(() => history.push('/login'), REDIRECT_DELAY_MS);
    }
  });

  useEffect(() => {
    if (!hasValidParameters) {
      history.push('/login');
      return;
    }

    mutate({ k: urlParams.k as string, status: urlParams.status as string });
  }, [urlParams.k, urlParams.status, history, mutate, hasValidParameters]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', textAlign: 'center' }}>
      <div style={{ flex: 1 }}>
        {isPending && (
          <div>
            <Spin />
            <h2 style={{ color: '#596375' }}>Aguarde, salvando alterações...</h2>
          </div>
        )}
        {isError && (
          <div>
            <span style={{ fontSize: 48, color: '#dc3f53' }}>
              <BugOutlined />
            </span>
            <h2 style={{ color: '#dc3f53' }}>Link inválido</h2>
          </div>
        )}
        {isSuccess && (
          <div>
            <span style={{ fontSize: 48, color: '#009358' }}>
              <CheckCircleOutlined />
            </span>
            <h2 style={{ color: '#009358' }}>{status} com sucesso</h2>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ModerateCoproducer;
